<template>
    <div class="user-profile-menu">
        <div class="user-profile-menu__header">
            <div class="user-profile-menu__avatar-info">
                <div class="user-profile-menu__avatar">
                    <!-- Placeholder if no image -->
                    <img v-if="user?.photoUrl" :src="user.photoUrl" alt="User Avatar" />
                    <div v-else class="avatar-placeholder"></div>
                </div>
                <div class="user-profile-menu__info">
                    <p class="user-profile-menu__name">{{ fullName }}</p>
                    <p class="user-profile-menu__login">@{{ user?.login || 'guest' }}</p>
                </div>
            </div>
            <p class="user-profile-menu__role">{{ formatRoleName(getMaxRole(user?.roles)) }}</p>
        </div>
        <div class="user-profile-menu__actions">
            <NavBarButton v-if="authStore.hasAdminToken" text="Вернуться в админ панель" :icon="UserCheckIcon"
                @click="authStore.reloginAsAdmin()" />
            <NavBarButton text="Настройки" :icon="SettingsIcon" @click="$router.push('/settings')" />
            <NavBarButton :text="themeStore.isDarkTheme ? 'Светлая тема' : 'Тёмная тема'" :icon="SliderIcon"
                @click="toggleTheme" />
            <NavBarButton text="Выйти" :icon="LogOutIcon" @click="logout" isRed />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/store/AuthStore';
import { useThemeStore } from '@/store/ThemeStore';
import { useUserStore } from '@/store/UserStore';
import { getMaxRole, formatRoleName } from '@/utils/role';
import SliderIcon from '@/assets/icons/Slider_03.svg';
import LogOutIcon from '@/assets/icons/Log_Out.svg';
import SettingsIcon from '@/assets/icons/Settings.svg';
import UserCheckIcon from '@/assets/icons/User_Check.svg';
import NavBarButton from '../ui/NavBarButton.vue';

const authStore = useAuthStore();
const themeStore = useThemeStore();
const userStore = useUserStore();

const user = computed(() => userStore.myUserInfo);

const fullName = computed(() => {
    if (!user.value) return 'Неизвестный';
    const name = user.value?.fullName.split(' ')
    return name[0] + ' ' + name[1] || 'Гость';
});

const toggleTheme = () => {
    themeStore.toggleTheme();
};

const logout = () => {
    authStore.logout();
};
</script>

<style lang="scss">
.user-profile-menu {
    padding: 10px;
    min-width: 200px;
    background-color: var(--color-bg);
    border-radius: 8px;
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); // Assuming parent handles shadow/dropdown style

    &__header {
        padding-bottom: 12px;
        border-bottom: 1px solid var(--color-border);
        margin-bottom: 10px;
    }

    &__avatar-info {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 6px;
    }

    &__avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        background-color: var(--color-bg-light);

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .avatar-placeholder {
            width: 100%;
            height: 100%;
            background-color: var(--color-primary); // Or any placeholder color
            opacity: 0.5;
        }
    }

    &__info {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    &__name {
        font-weight: 600;
        font-size: 14px;
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--color-text);
    }

    &__login {
        font-size: 12px;
        color: var(--color-text-secondary);
        margin: 0;
    }

    &__role {
        font-size: 11px;
        color: var(--color-primary);
        margin: 0;
        font-weight: 500;
        margin-left: 52px;
    }

    &__actions {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }
}
</style>
